const Menu = {
  variants: {
    clean: {
      list: {
        bg: 'white',
        borderRadius: '8px',
        border: '1px solid',
        borderColor: 'neutral.200',
        boxShadow: '0 4px 16px rgba(0, 0, 0, 0.08)',
        p: 1,
        overflow: 'hidden',
      },
      item: {
        fontWeight: '500',
        fontSize: 'sm',
        py: 2.5,
        px: 3,
        borderRadius: '4px',
        transition: 'all 0.15s ease',
        _hover: {
          bg: 'neutral.50',
        },
        _focus: {
          bg: 'neutral.50',
        },
      },
    },
    admin: {
      list: {
        bg: 'white',
        borderRadius: '8px',
        border: '1px solid',
        borderColor: 'neutral.200',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
        p: 1,
      },
      item: {
        fontWeight: '500',
        fontSize: 'sm',
        py: 2,
        px: 3,
        borderRadius: '4px',
        transition: 'all 0.15s ease',
        _hover: {
          bg: 'neutral.50',
        },
        _focus: {
          bg: 'neutral.50',
        },
      },
    },
  },
};

export default Menu;
